import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import unescapedText from 'I18n/utils/unescapedText';
import { getRefreshUrl } from '../helpers/getRefreshUrl';
import { jsx as _jsx } from "react/jsx-runtime";
const POPOVER_ILLUSTRATION_WIDTH = 130;
const UniversalAssociationsSelectError = () => {
  return /*#__PURE__*/_jsx(ErrorMessage, {
    marginBlockStart: "400",
    marginBlockEnd: "400",
    marginInline: "1000",
    illustrationProps: {
      width: POPOVER_ILLUSTRATION_WIDTH,
      marginBlockEnd: '400'
    },
    title: unescapedText('universalAssociationsSelect.errorSorry'),
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      elements: {
        Link
      },
      message: "universalAssociationsSelect.error_jsx",
      options: {
        href: getRefreshUrl()
      }
    })
  });
};
export default UniversalAssociationsSelectError;